import './index.less';

import { Button, ButtonProps, Space, Spinner } from '@tonic-one/react';
import React, { useMemo } from 'react';

interface LoadingBtnProps {
  disabled?: boolean;
  loading?: boolean;
  /**the children can be the button text */
  children: any;
  onClick?: Function;
  variant?: ButtonProps['variant'];
  style?: Object;
  [key: string]: any;
}

/**
 * @deprecated Use "@Components/Common/LoadingBtn" instead of this
 */
export default function LoadingBtn({
  disabled = false,
  loading,
  children,
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  onClick = () => {},
  variant = 'primary',
  style = {},
  ...rest
}: LoadingBtnProps) {
  const classes = useMemo(() => {
    let result = 'loadingBtn';
    if (loading) {
      result += ` loading`;
    }
    return result;
  }, [loading]);

  return (
    <Button
      disabled={disabled}
      variant={variant}
      className={classes}
      style={style}
      {...rest}
      onClick={() => {
        if (loading) return;
        onClick();
      }}
    >
      {loading && (
        <>
          <Spinner size="xs" lineColor="#fff" />
          <Space width="2x" />
        </>
      )}
      {children}
    </Button>
  );
}
